import React, { useEffect, useRef } from 'react'

import TagCloud from 'TagCloud'

const TEXTS = [
  'Solidity',
  'Rust',
  'Golang',
  'NodeJS',
  'Python',
  'Django',
  'Next.js',
  'React',
  'EVM',
  'ERC-20',
  'ERC-721',
  'Hyperledger',
  'Cosmos',
  'MPC',
  'RWA',
  'Docker',
  'Kubernetes',
  'AWS',
  'GCP',
  'PostgreSQL',
  'MongoDB',
  'Redis',
  'MySQL',
  'Moralis',
  'The Graph',
  'Git',
  'GitHub',
  'Vercel',
  'Netlify',
  'gRPC',
  'REST',
  'Web3',
  'Ethereum',
  'Base',
  'Binance',
  'Polygon',
]

const OPTIONS = {
  radius: 300,
  maxSpeed: 'fast',
  initSpeed: 'fast',
  direction: 135,
  keep: true,
}

const WordCloud = () => {
  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) return
    const tagcloud = TagCloud(containerRef.current, TEXTS, OPTIONS)
    return () => tagcloud.destroy()
  }, [])

  return (
    <div className="main tagcloud-skills">
      <span ref={containerRef}></span>
    </div>
  )
}

export default WordCloud
